// extracted by mini-css-extract-plugin
module.exports = {"deliveryDetails":"deliveryDetails_deliveryDetails__pXrj_","deliveryDetails__column":"deliveryDetails_deliveryDetails__column__xEa6d"};